import { Type } from "@scalar/typebox";
import { compose } from "../../../schemas/compose.js";
import {
  XScalarSecretHTTPSchema,
  XScalarSecretTokenSchema
} from "../../../schemas/extensions/security/x-scalar-security-secrets.js";
import { OAuthFlowsObjectRef } from "../../../schemas/v3.1/strict/ref-definitions.js";
const DescriptionSchema = Type.Object({
  /** A description for security scheme. CommonMark syntax MAY be used for rich text representation. */
  description: Type.Optional(Type.String())
});
const ApiKeySchema = compose(
  DescriptionSchema,
  XScalarSecretTokenSchema,
  Type.Object({
    /** REQUIRED. The type of the security scheme. Valid values are "apiKey", "http", "mutualTLS", "oauth2", "openIdConnect". */
    type: Type.Literal("apiKey"),
    /** REQUIRED. The name of the header, query or cookie parameter to be used. */
    name: Type.String(),
    /** REQUIRED. The location of the API key. Valid values are "query", "header", or "cookie". */
    in: Type.String()
  })
);
const HttpSchema = compose(
  DescriptionSchema,
  XScalarSecretTokenSchema,
  XScalarSecretHTTPSchema,
  Type.Object({
    /** REQUIRED. The type of the security scheme. Valid values are "apiKey", "http", "mutualTLS", "oauth2", "openIdConnect". */
    type: Type.Literal("http"),
    /** REQUIRED. The name of the HTTP Authentication scheme to be used in the Authorization header as defined in RFC7235. The values used SHOULD be registered in the IANA Authentication Scheme registry. The value is case-insensitive, as defined in RFC7235. */
    scheme: Type.String(),
    /** A hint to the client to identify how the bearer token is formatted. Bearer tokens are usually generated by an authorization server, so this information is primarily for documentation purposes. */
    bearerFormat: Type.Optional(Type.String())
  })
);
const OAuth2 = compose(
  DescriptionSchema,
  Type.Object({
    /** REQUIRED. The type of the security scheme. Valid values are "apiKey", "http", "mutualTLS", "oauth2", "openIdConnect". */
    type: Type.Literal("oauth2"),
    /** REQUIRED. An object containing configuration information for the flow types supported. */
    flows: OAuthFlowsObjectRef
  })
);
const OpenIdConnect = compose(
  DescriptionSchema,
  Type.Object({
    /** REQUIRED. The type of the security scheme. Valid values are "apiKey", "http", "mutualTLS", "oauth2", "openIdConnect". */
    type: Type.Literal("openIdConnect"),
    /** REQUIRED. Well-known URL to discover the [[OpenID-Connect-Discovery]] provider metadata. */
    openIdConnectUrl: Type.String()
  })
);
const SecuritySchemeObjectSchemaDefinition = Type.Union([ApiKeySchema, HttpSchema, OAuth2, OpenIdConnect]);
export {
  ApiKeySchema,
  DescriptionSchema,
  HttpSchema,
  OAuth2,
  OpenIdConnect,
  SecuritySchemeObjectSchemaDefinition
};
//# sourceMappingURL=security-scheme.js.map
